import React, { useEffect, useRef, useState } from "react";
import { InputText } from "primereact/inputtext";
import { Button } from "primereact/button";
import { handlePutRequest } from "../../../../services/PutTemplate";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "react-redux";
import { handleGetRequest } from "../../../../services/GetTemplate";
import Loading from "../../../../components/Loader";
import SecuredFileChange from "../../../../components/SecuredFileChange/SecuredFileChange";
import classNames from "classnames";
import { Dropdown } from "primereact/dropdown";
import { Dialog } from "primereact";
import baseURL, { endPoints } from "../../../../Config";

const EditViewCarModel = ({ onHide, getModelList, isEditable, modeldataId, setDisplayDialog }) => {
    const dispatch = useDispatch();
    const [loading, setLoading] = useState(false);
    const [allMaker, setAllMaker] = useState([]);
    const [allCategory, setAllCategory] = useState([]);
    const [selectedFile, setSelectedFile] = useState(null);
    const [selectedFileError, setSelectedFileError] = useState(null);
    const [modellogoLink, setModellogoLink] = useState("");
    const [loadingBtn, setLoadingBtn] = useState(false);
    const [displayImageDialog, setDisplayImageDialog] = useState(false);

    const modelImageRef = useRef(null);

    const getModelById = async () => {
        setLoading(true);
        const response = await dispatch(handleGetRequest(endPoints.getModelById(modeldataId), false));
        if (response?.statusCode === 200) {
            const keyData = response?.data;
            formik.setFieldValue("id", keyData?.id);
            formik.setFieldValue("categoryId", keyData?.categoryid);
            formik.setFieldValue("makerId", keyData?.makerid);
            formik.setFieldValue("isActive", keyData?.isActive);
            formik.setFieldValue("model_name", keyData?.model_name);
            formik.setFieldValue("model_images", keyData?.model_images);
            setModellogoLink(baseURL + "/" + keyData?.model_images);
        }
        setLoading(false);
    };
    useEffect(() => {
        getModelById();
    }, [modeldataId]);

    const validationSchema = Yup.object().shape({
        model_name: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, "Leading and trailing space is not allowed")
            .required("This field is required"),
        makerId: Yup.string().required("This field is required"),
        categoryId: Yup.string().required("This field is required"),
        model_images: Yup.string().required("This field is required"),
    });

    const formik = useFormik({
        validationSchema: validationSchema,
        initialValues: {
            id: "",
            categoryId: "",
            makerId: "",
            isActive: true,
            model_name: "",
            model_images: "",
        },

        onSubmit: async (data) => {
            setLoadingBtn(true);

            let obj = { id: data?.id, makerId: data?.makerId, isActive: data?.isActive, categoryId: data?.categoryId, model_name: data?.model_name, model_images: selectedFile ? selectedFile : undefined };
            const response = await dispatch(handlePutRequest(obj, endPoints.updateModel(data?.id), false, true));
            if (response?.statusCode == 200) {
                getModelList();
                onHide();
            }
            setLoadingBtn(false);
        },
    });
    const previewImage = () => {
        if (modellogoLink) {
            setDisplayImageDialog(true);
        }
    };
    const closeDisplayImageDialog = () => {
        setDisplayImageDialog(false);
    };

    const handleImageReset = () => {
        formik.setFieldValue("model_images", "");
        setSelectedFile(null);
        setModellogoLink("");
        modelImageRef.current.value = null; // Reset the file input value
    };
    const handleModelIcon = () => {
        modelImageRef.current.click();
    };

    function handleModelImageChange(event) {
        setSelectedFile(null);
        formik.setFieldValue("model_images", "");
        setSelectedFileError("");
        const selectedFile = event.target.files[0];
        const fileTypes = ["image"];
        const { file: newFile, error } = SecuredFileChange(selectedFile, fileTypes);
        if (error) {
            setSelectedFileError(error);
        } else if (newFile) {
            setModellogoLink(URL.createObjectURL(selectedFile));
            formik.setFieldValue("model_images", newFile?.name);
            const reader = new FileReader();
            reader.onloadend = () => {
                const base64String = reader.result;
                setSelectedFile(base64String);
            };
            reader.readAsDataURL(newFile);
        }
    }

    const getMakerList = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getallMakers, false));
        if (response) {
            const filteredMakers = response?.data?.filter((item) => {
                return item?.isActive === true;
            });
            setAllMaker(filteredMakers);
        }
    };
    const getCategoryList = async () => {
        const response = await dispatch(handleGetRequest(endPoints.getallCategory, false));
        if (response) {
            const filteredCategories = response?.data?.filter((item) => {
                return item?.isActive === true;
            });
            setAllCategory(filteredCategories);
        }
    };

    useEffect(() => {
        getMakerList();
        getCategoryList();
    }, []);

    const isFormFieldValid = (name) => !!(formik.touched[name] && formik.errors[name]);
    const getFormErrorMessage = (name) => {
        return isFormFieldValid(name) && <small className="p-error">{formik.errors[name]}</small>;
    };

    return (
        <>
            {modellogoLink && (
                <Dialog visible={displayImageDialog} style={{ width: "40vw" }} maskClassName="zindex9999" onHide={() => closeDisplayImageDialog()} draggable={false}>
                    <img src={modellogoLink} style={{ maxWidth: "100%", maxHeight: "100%", width: "900px", height: "500px", objectFit: "contain" }} />
                </Dialog>
            )}

            {loading ? <Loading /> : <></>}
            <form onSubmit={formik.handleSubmit}>
                <div className="p-fluid formgrid grid pl-2 pr-2">
                    <div className="field col-12 md:col-6">
                        <label> Model </label>
                        <span className="Label__Required">*</span>
                        <InputText
                            placeholder="Enter Model Name"
                            className={classNames({ "p-invalid": isFormFieldValid("model_name") }, "Input__Round")}
                            id="model_name"
                            name="model_name"
                            type="text"
                            maxLength={30}
                            value={formik.values.model_name}
                            onChange={formik.handleChange}
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("model_name")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Maker Name </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            className={classNames({ "p-invalid": isFormFieldValid("makerId") }, "Dropdown__Round")}
                            id="makerId"
                            name="makerId"
                            options={allMaker}
                            optionValue="id"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.makerId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("makerId", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.makerId}
                            placeholder="Select Maker"
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("makerId")}
                    </div>
                    <div className="field col-12 md:col-6">
                        <label> Category </label>
                        <span className="Label__Required">*</span>
                        <Dropdown
                            className={classNames({ "p-invalid": isFormFieldValid("categoryId") }, "Dropdown__Round")}
                            id="categoryId"
                            name="categoryId"
                            options={allCategory}
                            optionValue="id"
                            optionLabel="name"
                            filter
                            showClear={!!formik?.values?.categoryId}
                            filterBy="name"
                            showFilterClear={true}
                            resetFilterOnHide={true}
                            onChange={(e) => {
                                formik?.setFieldValue("categoryId", e.target.value ? e.target.value : "");
                            }}
                            value={formik.values.categoryId}
                            placeholder="Select Category"
                            disabled={!isEditable}
                        />
                        {getFormErrorMessage("categoryId")}
                    </div>

                    <div className="field col-12 md:col-6">
                        <label> {isEditable ? "Upload Image" : "Model Image"} </label>
                        {isEditable && (
                            <>
                                <div className="file-input-container " onClick={handleModelIcon}>
                                    <input type="file" accept="image/*" style={{ display: "none" }} ref={modelImageRef} onChange={handleModelImageChange} disabled={!isEditable} />
                                    <input className={classNames({ "p-invalid": isFormFieldValid("model_images") }, "custom-file p-inputtext p-component Input__Round")} type="text" placeholder="Choose a file..." value={formik.values.model_images} readOnly />
                                    <span className="file-upload-icon">
                                        <i className="pi pi-paperclip" />
                                    </span>
                                </div>
                                {selectedFileError ? <small className="p-error">{selectedFileError}</small> : getFormErrorMessage("model_images")}
                            </>
                        )}
                        {formik?.values?.model_images && (
                            <div style={{ position: "relative", width: "180px", height: "180px", margin: "auto", marginTop: "15px" }}>
                                {isEditable ? <i className="pi pi-times closingIcon" onClick={() => handleImageReset()} style={{ cursor: "pointer", position: "absolute", top: "0", right: "0" }} disabled={!isEditable} /> : ""}
                                <img
                                    src={modellogoLink}
                                    alt="Model Image"
                                    style={{ maxWidth: "100%", maxHeight: "100%", width: "150px", height: "150px", objectFit: "contain" }}
                                    onClick={() => {
                                        previewImage();
                                    }}
                                />
                            </div>
                        )}
                    </div>
                    <div className="col-12 d-flex flex-row text-center mt-4 pb-2">
                        <Button className="Cancel-Button" label="Cancel" type="button" onClick={onHide} />
                        {isEditable === true && <Button className="Save-Button ml-2" label="Update" type="submit" loading={loadingBtn} />}
                    </div>
                </div>
            </form>
        </>
    );
};

export default EditViewCarModel;
